export default __webpack_public_path__ + "static/media/AntyLucy_19.27895992.jpg";